import React from "react";
import { Table } from "reactstrap";

const MaturityTable = ({ data }) => {
    if (!data) return null;

    const { headers, rows, styles } = data;
    const borderColor = styles?.borderColor || "#ccc";

    return (
        <div className="table-responsive mb-4">
            <Table bordered className="mb-0">
                <thead>
                    <tr>
                        {headers?.map((header, i) => (
                            <th
                                key={i}
                                style={{
                                    backgroundColor: styles?.headerBg || "#2f4a7f",
                                    color: styles?.headerText || "#fff",
                                    borderColor,
                                    fontWeight: "600",
                                    minWidth: "90px"
                                }}
                            >
                                {header}
                            </th>
                        ))}
                    </tr>
                </thead>

                <tbody>
                    {rows?.map((row, index) => (
                        <tr key={index}>
                            {/* Level */}
                            <td
                                style={{
                                    backgroundColor: row.color,
                                    borderColor,
                                    fontWeight: "600"
                                }}
                            >
                                {row.level}
                            </td>

                            {/* Stage */}
                            <td
                                style={{
                                    backgroundColor: row.color,
                                    borderColor,
                                    fontWeight: "600"
                                }}
                            >
                                {row.stage}
                            </td>

                            {/* Description */}
                            <td
                                style={{
                                    backgroundColor: row.color,
                                    borderColor
                                }}
                            >
                                {row.description}
                            </td>

                            {/* Tools */}
                            <td
                                style={{
                                    backgroundColor: row.color,
                                    borderColor,
                                    fontStyle: "italic"
                                }}
                            >
                                {row.tools}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default MaturityTable;